const IMG_STORAGE =process.env.REACT_APP_IMG_STORAGE_URL;

export function getProfileImageUrl(imagePath) {
  return `${IMG_STORAGE}/avatars/${imagePath}`;
}
export function getCourseImageUrl(imagePath) {
  return `${IMG_STORAGE}/course_images/${imagePath}`;
}

/**
 * Determines how to handle avatar URLs based on their source
 * @param {string} avatar - The avatar URL or path
 * @param {string|null} googleId - The user's Google ID if they used Google sign-in
 * @returns {object} - Object with { url: string, isExternal: boolean, isGoogle: boolean }
 */
export function getUserAvatar(avatar, googleId = null) {
  if (!avatar) {
    return { url: null, isExternal: false, isGoogle: false };
  }
  
  // Fix escaped slashes that might be in the URL
  const fixedAvatar = avatar.replace ? avatar.replace(/\\\//g, '/') : avatar;
  
  // Check if this is a Google avatar URL
  const isGoogleAvatar = 
    (typeof fixedAvatar === 'string') && (
      fixedAvatar.includes('googleusercontent.com') || 
      fixedAvatar.includes('lh3.google.com') ||
      fixedAvatar.includes('lh5.googleusercontent.com') ||
      fixedAvatar.includes('lh6.googleusercontent.com') ||
      (googleId && fixedAvatar.includes(googleId))
    );
  
  // Check if this is any external URL
  const isExternalUrl = 
    (typeof fixedAvatar === 'string') && (
      fixedAvatar.startsWith('http://') || 
      fixedAvatar.startsWith('https://') ||
      isGoogleAvatar
    );
  
  // If it's a Google avatar URL, ensure it has the correct parameters
  if (isGoogleAvatar) {
    let processedUrl = fixedAvatar;
    
    // Remove any existing size parameters and fragments
    if (processedUrl.includes('=s')) {
      processedUrl = processedUrl.replace(/=s\d+.*?$/, '');
    }
    
    // Remove any trailing fragments or query parameters
    if (processedUrl.includes('#')) {
      processedUrl = processedUrl.split('#')[0];
    }
    
    // For Google avatars, use a simpler approach that's more likely to work
    // Try without the -c parameter first
    processedUrl = `${processedUrl}=s240`;
    
    return { 
      url: processedUrl, 
      isExternal: true,
      isGoogle: true
    };
  }
  
  // If it's another external URL, return it directly
  if (isExternalUrl) {
    return { url: fixedAvatar, isExternal: true, isGoogle: false };
  }
  
  // Otherwise, it's a local avatar that needs the full path
  return { url: getProfileImageUrl(fixedAvatar), isExternal: false, isGoogle: false };
}
 
  

